export default __webpack_public_path__ + "static/media/SBBCM.0289cb04.png";